<div *ngIf="leftNavOptions" class="left-navigation aem-GridColumn aem-GridColumn--default--12">
    <div class="left-navigation-level">
        <div class="left-navigation-level__sub-banner d-none d-lg-block" tabindex="-1" data-qa="lft-nvgtn-lvl-ttl">
            {{leftNavOptions.titleText}}
        </div>

        <nav class="left-navigation-level__categories-tree dropdown" aria-label="secondary navigation">
            <button class="left-navigation-level__btn dropdown-toggle d-block d-lg-none" type="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="leftNavStaticBtn"
                    aria-controls="leftNavStaticMenu">
                <span class="left-navigation-level__main-text">
                                      Games
                </span>
                <span class="left-navigation-level__icon svg-icon svg-icon-Arrow_down_black" role="img"
                      aria-hidden="true"></span>
            </button>
            <ul class="left-navigation-level__dropdown-menu dropdown-menu d-lg-block" aria-labelledby="dropdown-menu">
                <li *ngFor="let navItem of leftNavOptionsList; let i = index">
                    <a [ngClass]="{'active': navItem.menuLink.indexOf('games') >= 0}"
                       class="left-navigation-level__link user-protected-link user-prompt-a user-prompt-g "
                       href="{{navItem.menuLink}}" aria-current="false" aria-label="Coupons &amp; Deals."
                       data-qa="lft-nvgtn-lvl-lnk">{{navItem.menuText}}</a>
                    <img class="left-navigation-level__image d-none" alt="" role="presentation"
                         src="/etc/designs/wcax-commons/images/icons/Across_Icon.svg">
                </li>
            </ul>
        </nav>
    </div>
</div>
